import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StoreService } from '../../feature/store-admin/services/store.service';
import { ErrorhandlerService } from '../../shared/services/errorhandler/errorhandler.service';
import { NotificationService } from '../../core/services/notification/notification.service';

@Component({
  selector: 'app-confirm-dialouge',
  templateUrl: './confirm-dialouge.component.html',
  styleUrls: ['./confirm-dialouge.component.css']
})
export class ConfirmDialougeComponent implements OnInit {
  DialogueData: any;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialougeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public storeService: StoreService, private notification: NotificationService, public errorhandlerService: ErrorhandlerService 
  ) { }

  ngOnInit() {    
    this.DialogueData = this.data;
  }


  onConfirmClick(StoreId: any): void {
    this.storeService.DeleteStore(StoreId).subscribe((res: any) => {   
      if (res.StatusCode === 200) {
        this.notification.success(res.Message, 'Store Deleted Successfuly');
        window.location.reload();
      } else {
        this.notification.error(res.Message, 'Error');
      }
    }, (err: any) => {
      // this.loader.hide();
      this.errorhandlerService.handleError(err);
    });    
    this.dialogRef.close(true);
  }
  closeDialog(value): void {
    $(".body").css("filter", "blur(0px)");
    this.dialogRef.close(value);
  }

    

}
